import angular from "angular";
import RestangularModule from "./restangular";
import AppConfigModule from "./app.config";

let apiModule = angular
  .module("app.api", [RestangularModule, AppConfigModule])
  .run((Restangular, $state, AppConfig, $timeout) => {
    "ngInject";
    
    Restangular.setBaseUrl(AppConfig.server_url);
    Restangular.setDefaultHttpFields({withCredentials: true});
    Restangular.setDefaultHeaders({locale: window.localStorage.yuanben_lang});
    Restangular.addResponseInterceptor(function (data, operation, what, url, response, defered) {
      if (data.hasOwnProperty("block_source")) {
        if (data.block_source === 0) {
          data.chain_server_url = `${
            AppConfig.chain_server_url
            }/block/${data.block_hash}`;
        } else {
          data.chain_server_url = `${AppConfig.newchain_server_url}/original/${
            data.yuanben_id
            }`;
        }
      }
      return data;
    });

    Restangular.setErrorInterceptor((response, deferred, responseHandler) => {
      if (response.status === 401) {
        $timeout(() => {
          location.href = "/login";
        }, 0);

        return false;
      }
    });
  })

  .factory("AuthorAPI", Restangular => {
    "ngInject";
    return Restangular.service("authors");
  })

  .factory("ArticleAPI", Restangular => {
    "ngInject";
    return Restangular.service("articles");
  })

  .factory("UserAPI", Restangular => {
    "ngInject";
    return Restangular.service("user");
  })


  .factory("AnnouncementAPI", Restangular => {
    "ngInject";
    return Restangular.service("announcements");
  })

  .factory("NewAPI", Restangular => {
    "ngInject";
    return Restangular.service("news");
  })

  .factory("AnnouncementTagAPI", Restangular => {
    "ngInject";
    return Restangular.service("news");
  })

  .factory("QueryAPI", Restangular => {
    "ngInject";
    return Restangular.service("query");
  })

  .factory("OrderAPI", Restangular => {
    "ngInject";
    return Restangular.service("orders");
  })
  .factory("OrderEmailAPI", Restangular => {
    "ngInject";
    return Restangular.service("order/email")
  })

  .factory("ReceiptAPI", Restangular => {
    "ngInject";
    return Restangular.service("receipts");
  })
  .factory("ImageAPI", Restangular => {
    "ngInject";
    return Restangular.service("images");
  })

  .factory("InfringementAPI", Restangular => {
    "ngInject";
    return Restangular.service("infringements");
  })

  .factory("EvidenceAPI", Restangular => {
    "ngInject";
    return Restangular.service("evidences");
  })
  .factory("ForensicsFeesAPI", Restangular => {
    "ngInject";
    return Restangular.service("evidences/pay");
  })
  .factory("evidencesAgainAPI", Restangular => {
    "ngInject";
    return Restangular.service("evidences/again");
  })

  .factory("ImportAPI", Restangular => {
    "ngInject";
    return Restangular.service("import");
  })
  .factory("CollectionAPI", Restangular => {
    "ngInject";
    return Restangular.service("resources/collections");
  })
  .factory("NotificationAPI", Restangular => {
    "ngInject";
    return Restangular.service("user/notifications");
  })
  .factory("WXpayAPI", Restangular => {
    "ngInject";
    return Restangular.service("media/weixin/oauth");
  })

  .factory("NoLoginPayAPI", Restangular => {
    "ngInject";
    return Restangular.service("none/pay");
  })

  .factory("UserNotificationSignAPI", Restangular => {
    "ngInject";
    return Restangular.service("user/authorization/sign");
  })

  .factory("PluginVersionAPI", Restangular => {
    "ngInject";
    return Restangular.service("plugin/latest/version");
  })

  .factory("PartnerAPI", Restangular => {
    "ngInject";
    return Restangular.service("partner/application");
  })
  .factory("applicationAPI", Restangular => {
    "ngInject";
    return Restangular.service("intelligence/application");
  })
  .factory("RechargeAPI", Restangular => {
    "ngInject";
    return Restangular.service("payment/account/recharge");
  })
  .factory("manageListAPI", Restangular => {
    "ngInject";
    return Restangular.service("/group");
  })
  .factory("reEvidencesReportAPI", Restangular => {
    "ngInject";
    return Restangular.service("/evidences/report");
  })

  .factory("SimilarityCompareAPI", Restangular => {
    "ngInject";
    return Restangular.service("text/similarity/compare");
  })
  .factory("downloadEvidencePackageApi", Restangular => {
    "ngInject";
    return Restangular.service(`articles`);
  })
  .factory("ImgDetailRecommendListApi", Restangular => {
    "ngInject";
    return Restangular.service(`query/image/recommend`);
  })








  .name;

export default apiModule;



// WEBPACK FOOTER //
// ./src/app/app.api.js